import type { RetailersApiResponse } from '#constants/types/norce';
import type { LatLng } from '~/util/distance';
import useApiFetch from '~/composables/useApiFetch';

export type RetailerLocation = LatLng & {
  accountid: string,
  accountNumber: string,
  name: string,
  addressLine1: string,
  postalcode: string,
  city: string,
  phone: string | null,
  email: string | null,
  website: string,
};

/**
 * Shared list of retailers (coordinates and contact details).
 * Fetched once per page load no matter how many components ask for it.
 */
export default function useRetailerLocations() {
  const { apiGet } = useApiFetch();
  const retailers = useState<RetailerLocation[] | null>('retailerLocations', () => null);
  const loading = useState('retailerLocationsLoading', () => false);

  const load = async() => {
    if (retailers.value || loading.value) {
      return;
    }
    loading.value = true;
    const res = await apiGet<RetailersApiResponse>('/retailers').catch(() => null);
    retailers.value = (res?.stores ?? [])
      .filter(s => s.showonweb)
      .map(s => ({
        accountid: s.accountid,
        accountNumber: s.accountNumber,
        name: s.name,
        lat: s.latitude,
        lng: s.longitude,
        addressLine1: s.addressLine1,
        postalcode: s.postalcode,
        city: s.city,
        phone: s.phone,
        email: s.email,
        website: s.website,
      }));
    loading.value = false;
  };

  return { retailers, load };
}
